import { GET_CUISINES_REQUEST,
    GET_CUISINES_SUCCESS,
    GET_CUISINES_FAILURE } from '../../actions/profile/constants';

const INITIAL_STATE = {
    fetching: false,
    error: false,
    errorMsg: null,
    all: []
}

export default function cuisines(state = INITIAL_STATE, action)  {
    switch (action.type) {
        case GET_CUISINES_REQUEST:
            return {
                ...state,
                fetching: true,
            }
        case GET_CUISINES_SUCCESS:
            return {
                ...state,
                all: action.payload,
                fetching: false,
            }
        case  GET_CUISINES_FAILURE:
            return {
                ...state,
                fetching: false,
                error: true,
                errorMsg: action.error
            }
        default:
            return state;
    }
}